import { Component, EventEmitter, Output, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { EquipFieldData } from '@app/cp/shared/models/EquipFieldData';
import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { BaseDQOIComponent } from '@app/cp/shared/base-components/base-dqoi.component';
import { FileInfo, SelectEvent, FileRestrictions } from '@progress/kendo-angular-upload';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';

@Component({
    selector: 'equip-custom-fields',
    templateUrl: './equip-custom-fields.component.html',
    styleUrls: ['./equip-custom-fields.component.scss']
})
export class EquipCustomFieldsComponent  {

    constructor(private sanitizer: DomSanitizer) {
    }
    @Output() saveEvent: EventEmitter<EquipFieldData> = new EventEmitter<EquipFieldData>();
    @Output() cancelEvent: EventEmitter<any> = new EventEmitter<any>();

    data: EquipFieldData;
    editForm: UntypedFormGroup;
    active: boolean = false;

    get referenceData(): DQOIReferenceData {
        return BaseDQOIComponent._referenceData;
    }

    hide() {
        this.active = false;
    }
    cancel(e: any) {
        e.stopPropagation();
        this.hide();
        this.cancelEvent.emit();
    }
    readOnly = false;
    show(data: EquipFieldData,readOnly:boolean) {
        this.data = data;
        this.createForm();
        this.setForm();
        this.showImage();
        this.active = true;
        this.readOnly = readOnly
    }
    equipImage: any;
    showImage() {
        if (CommonFunctions.hasValue(this.data.equipImg)) {
            this.equipImage = this.sanitizer.bypassSecurityTrustResourceUrl("data:image/png;base64," + this.data.equipImg);
        }
    }
    createForm() {
        this.editForm = new UntypedFormGroup({
            'equipFieldDataId': new UntypedFormControl(),
            'equipmentId': new UntypedFormControl(),
            'col1Data': new UntypedFormControl(),
            'col2Data': new UntypedFormControl(),
            'col3Data': new UntypedFormControl(),
            'col4Data': new UntypedFormControl(),
            'col5Data': new UntypedFormControl(),
            'col6Data': new UntypedFormControl(),
            'col7Data': new UntypedFormControl(),
            'col8Data': new UntypedFormControl(),
            'col9Data': new UntypedFormControl(),
            'col10Data': new UntypedFormControl(),
            'equipImg': new UntypedFormControl(),
            'equipDocUrl': new UntypedFormControl(),
            'insertUserId': new UntypedFormControl(),
            'insertDt': new UntypedFormControl()
        });

    }
    setForm() {
        this.editForm.patchValue({
            equipFieldDataId: this.data.equipFieldDataId,
            equipmentId: this.data.equipmentId,
            col1Data: this.data.col1Data,
            col2Data: this.data.col2Data,
            col3Data: this.data.col3Data,
            col4Data: this.data.col4Data,
            col5Data: this.data.col5Data,
            col6Data: this.data.col6Data,
            col7Data: this.data.col7Data,
            col8Data: this.data.col8Data,
            col9Data: this.data.col9Data,
            col10Data: this.data.col10Data,
            equipImg: this.data.equipImg,
            equipDocUrl: this.data.equipDocUrl,
            insertUserId: this.data.insertUserId,
            insertDt: this.data.insertDt,
        });
    }
    save(e: any) {
        e.stopPropagation();
        this.saveEvent.emit(this.editForm.value);
        this.hide();

    }

    files: Array<FileInfo> = [];
    uploadSaveUrl: string = "";
    uploadRemoveUrl: string;
    uploadRestrictions: FileRestrictions = {
        allowedExtensions: ['.jpg', '.png', '.gif']
    };
    public myFiles: any[] = [];
    selectEventHandler(e: SelectEvent) {
            this.files = e.files;
            e.files.forEach((file) => {
                if (!file.validationErrors && file.rawFile) {
                    const previewUrl = URL.createObjectURL(file.rawFile);
                    this.equipImage = previewUrl;
                }
            });
            
            this.myFiles = [];
        }
}

